import { useMutation } from '@apollo/react-hooks'
import ImageTeacher from '@berlitzplatforms/micro.image.teacher'
import ImageTrophyCelebrateSimple from '@berlitzplatforms/micro.image.trophy-celebrate-simple'
import NotificationCard from '@berlitzplatforms/micro.ui.notification-card'
import PortalLearningPath from '@classes/LearningPath'
import AllLevelsNotificationCard from '@components/AllLevelsNotificationCard'
import FormattedHTMLMessage from '@components/FormattedHTMLMessage'
import { LoadingModal } from '@components/Modal'
import AllYouCanLearnConfirmationModal from '@components/Modal/AllYouCanLearnConfirmationModal'
import useEnsureNoDisplayedModal from '@hooks/useEnsureNoDisplayedModal'
import { NxtLvlCtr } from '@layouts/LearningPath/Layout/style'
import { PUT_REGISTRATION_FLEX_LEVEL_STATUS } from '@queries/registrations'
import { FLEX_LEVEL_STATUS } from '@utils/constants'
import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { getStorageAdapter } from '@shell/adapters/storage'
const LPNotificationCard: React.FC<{
  path?: PortalLearningPath
  isMyBerlitzTutorProgram?: boolean
  isSkillsTutorProgram?: boolean
  noActiveSkillsTutor?: boolean
}> = ({ path, isMyBerlitzTutorProgram = false, isSkillsTutorProgram = false, noActiveSkillsTutor = false }) => {
  const [updateFlexLevelStaus, { loading: updatingFlexLevel }] = useMutation(PUT_REGISTRATION_FLEX_LEVEL_STATUS, {
    onCompleted: () => {
      close()
      location.reload()
    },
  })
  const [openRNLModal, setOpenRNLModal] = useState(false)
  const intl = useIntl()
  const router = useRouter()
  useEnsureNoDisplayedModal(() => {
    if (path && path.IsOnDemand && path.ReadyForNextLvl && !getStorageAdapter().get(path.tempFlags.ReadyForNextLvl)) {
      setOpenRNLModal(true)
    }
  }, [path])
  const close = () => {
    path && getStorageAdapter().set(path.tempFlags.ReadyForNextLvl, 'true')
    setOpenRNLModal(false)
  }
  const createCase = () => {
    router.push('/support/contact-us/?id=feedback&cat=Other')
  }
  const startNextLvl = () => {
    setOpenRNLModal(true)
  }
  const book = () => {
    close()
    router.push(`/scheduling/single-lesson?programid=${path?.Program?.ProgramId}&unitId=0000&LPId=${path?.Id}`)
  }
  const goToNextLvl = () => {
    updateFlexLevelStaus({
      variables: {
        registrationInput: [
          {
            RegistrationInfo: {
              RegistrationId: path?.Material?.RegistrationId,
              FlexLevelStatus: FLEX_LEVEL_STATUS.ENROLMENT_INPROGRESS,
            },
          },
        ],
      },
    })
    // temp flag so we know that enrolment is in progress
    path && getStorageAdapter().set(path.tempFlags.EnrolmentInProgress, 'true')
    close()
  }
  return (
    <>
      {path?.HasContractEnded ? (
        <NxtLvlCtr>
          <NotificationCard
            maxWidth="600px"
            simpleTitle={intl.formatMessage({
              id: 'Your contract has expired',
              defaultMessage: 'Your contract has expired',
            })}
            simpleMessage={intl.formatMessage({
              id: `Interested in extending your subscription or enrolling in a different course? Contact us, we're here to help.`,
              defaultMessage: `Interested in extending your subscription or enrolling in a different course? Contact us, we're here to help.`,
            })}
            onButtonClick={createCase}
            buttonLabel={intl.formatMessage({ id: 'Contact us', defaultMessage: 'Contact us' })}
          ></NotificationCard>
        </NxtLvlCtr>
      ) : path?.HasCompletedAllYouCanLearn ? (
        <NxtLvlCtr>
          {!isMyBerlitzTutorProgram && !isSkillsTutorProgram && (
            <AllLevelsNotificationCard lp={path.AYCLSequence} isOnDemand={path.IsOnDemand} />
          )}
        </NxtLvlCtr>
      ) : path?.IsAllLvlUnliLCS && !path?.IsPased2Days && !path.IsOnDemand ? (
        <NxtLvlCtr>
          <NotificationCard
            image={<ImageTeacher />}
            maxWidth="527px"
            simpleTitle={intl.formatMessage(
              {
                id: 'An instructor is reviewing your results for level {level}',
                defaultMessage: 'An instructor is reviewing your results for level {level}',
              },
              { level: path?.Material?.languageLevel }
            )}
            simpleMessage={intl.formatMessage({
              id: 'This could take a few hours. In the meantime continue with unlimited live coaching sessions and lessons.',
              defaultMessage:
                'This could take a few hours. In the meantime continue with unlimited live coaching sessions and lessons.',
            })}
            messageAlignment="left"
          />
        </NxtLvlCtr>
      ) : path?.ReadyForNextLvl ? (
        <NxtLvlCtr>
          {!isMyBerlitzTutorProgram && !isSkillsTutorProgram && (
            <NotificationCard
              image={<ImageTrophyCelebrateSimple />}
              maxWidth="612px"
              simpleTitle={intl.formatMessage({
                id: 'Congratulations!',
                defaultMessage: 'Congratulations!',
              })}
              simpleMessage={
                <FormattedHTMLMessage
                  id={`You've successfully completed {lp}! You can now progress to level {lvl}.`}
                  defaultMessage={`You've successfully completed {lp}! You can now progress to level {lvl}.`}
                  values={{
                    lvl: `<span style="color: #004fef; font-weight: 500;">${path?.NextLvl}</span>`,
                    lp: `<span style="color: #004fef; font-weight: 500;">${path?.MaterialCore?.MaterialName}</span>`,
                  }}
                />
              }
              onButtonClick={startNextLvl}
              buttonLabel={intl.formatMessage({ id: 'Start next level', defaultMessage: 'Start next level' })}
            ></NotificationCard>
          )}
        </NxtLvlCtr>
      ) : path?.EnrolmentInProgress ? (
        <NxtLvlCtr>
          <NotificationCard
            image={<ImageTrophyCelebrateSimple />}
            maxWidth="625px"
            panelMessage={intl.formatMessage({
              id: 'We’re preparing your next level. This could take 5 to 10 minutes.',
              defaultMessage: 'We’re preparing your next level. This could take 5 to 10 minutes.',
            })}
            simpleTitle={intl.formatMessage(
              {
                id: '{name} loading...',
                defaultMessage: '{name} loading...',
              },
              { name: path?.Material?.partialName + ` ${Number(path?.Material?.languageLevel) + 1}` }
            )}
          />
        </NxtLvlCtr>
      ) : noActiveSkillsTutor ? (
        <NxtLvlCtr>
          <NotificationCard
            maxWidth="600px"
            simpleTitle={intl.formatMessage({
              id: 'Your contract has expired',
              defaultMessage: 'Your contract has expired',
            })}
            simpleMessage={intl.formatMessage({
              id: `Interested in extending your subscription or enrolling in a different course? Contact us, we're here to help.`,
              defaultMessage: `Interested in extending your subscription or enrolling in a different course? Contact us, we're here to help.`,
            })}
            onButtonClick={createCase}
            buttonLabel={intl.formatMessage({ id: 'Contact us', defaultMessage: 'Contact us' })}
          ></NotificationCard>
        </NxtLvlCtr>
      ) : null}
      <AllYouCanLearnConfirmationModal
        open={openRNLModal}
        onClose={close}
        onCancel={book}
        onProceed={goToNextLvl}
        isOnDemand={path?.IsOnDemand}
      />
      <LoadingModal
        open={updatingFlexLevel}
        onClose={() => {}}
        title={`${intl.formatMessage({
          id: 'Updating course...',
        })}`}
        subtitle={`${intl.formatMessage({ id: 'Please wait a moment' })}.`}
      />
    </>
  )
}
export default LPNotificationCard
